export class procesamientoDatos {
    listTiempoProm = []
    listTiempoPromData = [];
    tendenciasMesas
    service
    totalMesas

    conteopormesa
    numeraciondemesa

    encuesta = []

    comentarios = []

    tablaRespuestas = []

    reset(){

    this.listTiempoProm = []
    this.listTiempoPromData = [];
    this.tendenciasMesas
    this.service
    this.totalMesas

    this.conteopormesa
    this.numeraciondemesa

    this.encuesta = []

    this.comentarios = []

    this.tablaRespuestas = []
    
    }

    tarjetaPromedio(data, promedio) {
        /* console.log("data", data); */

        if (data.length < 0) {
            return promedio
        }

        let prom = 0;
        data.forEach((element, index) => {
            /* console.log(element); */
            /*User:${element.user.status ? element.user.name.status : 'Anoniomo'} Fecha:Mesa:${element.date} */
            
            if (element.hasOwnProperty("listServices")) {
                element.listServices.forEach(time => {

                    this.listTiempoProm.push(this.tiempoTranscurrido(time.start, time.end));

                    this.listTiempoPromData.push(`${element.mesa}`);

                    this.conteopormesa[element.mesa - 1]++;
                    
                    promedio = promedio + this.calcularTiempoTranscurrido(time.start, time.end);
                    
                });
                
            }
            if (element.hasOwnProperty("rattinggs")) {

                this.getEncuesta(element.rattinggs, element.date);
            };
            this.tablaRespuestas.push(element);
        });

        
        return promedio

    }

    getcomentarios(element, date) {
        if (element.respuesta.replace(/\s/g, "").length == 0) {
            return
        }
        const index = this.comentarios.findIndex(item => item.pregunta == element.pregunta);
        if (index !== -1) {
            const { respuesta, ...dat } = element;
            this.comentarios[index].respuesta.push({ "respuesta": respuesta, 'date': date });
            return
        }

        if (index == -1) {
            const { respuesta, ...dat } = element;
            dat.respuesta = [{ "respuesta": respuesta, 'date': date }]
            this.comentarios.push(dat);
            return
        }
    }

    getEncuesta(data, date) {

        if (data.length == 0) {
            return 0;
        }
        
        
        data.forEach(element => {
            
            
            if (element.tipo == 4) {
                this.getcomentarios(element, date);
                return;
            }
            if (typeof data.respuesta === 'string') { return }

            const index = this.encuesta.findIndex(item => item.pregunta == element.pregunta);
            if (index !== -1) {
                
                this.encuesta[index] = this.conteotranscurrido(element, this.encuesta[index])
            } else {
                
                
                this.encuesta.push(this.conteotranscurrido(element, this.returndatajcharts(element)));

            }
           

        });

    }   

    returndatajcharts(data) {
        data.line = {
            data: {
                labels: [],
                datasets: []
            },
        };

        data.polar = {
            data: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [],
                        label: [``]
                    },
                ],
            },
        };

        data.line.data.labels = [data.pregunta];
        data.polar.data.datasets[0].label = [data.pregunta];
        if (data.tipo == 2 || data.tipo == 3) {
            data.line.data.datasets = [
                {
                    label: "Muy Malo",
                    data: [0],
                    backgroundColor: ["rgba(245, 0, 87, 0.5)"],
                    borderWidth: 1,
                    borderColor: ["rgba(142, 0, 0, 0.6)"],
                },
                {
                    label: "Regular",
                    data: [0],
                    backgroundColor: ["rgba(255, 176, 0, 0.5)"],
                    borderWidth: 1,
                    borderColor: ["rgba(249, 168, 37, 0.6)"],
                },
                {
                    label: "Muy bueno",
                    data: [0],
                    backgroundColor: ["rgba(0, 191, 165, 0.5)"],
                    borderWidth: 1,
                    borderColor: ["rgba(27, 94, 32, 0.6)"],
                }
            ];


            data.polar.data.labels = [
                "Malo",
                "Regular",
                "Muy bueno",
            ];
            data.polar.data.datasets[0].backgroundColor = [
                "rgba(255, 0, 0, 0.5)",
                "rgba(247, 252, 0, 0.5)",
                "rgba(0, 247, 0, 0.5)",
            ];
            data.polar.data.datasets[0].data = [0, 0, 0];
        }

        if (data.tipo == 3) {

            data.line.data.datasets.splice(1, 0, {
                label: "Malo",
                data: [0],
                backgroundColor: ["rgba(255, 111, 97, 0.5)"],
                borderWidth: 1,
                borderColor: ["rgba(239, 108, 0, 0.6)"],
            });

            data.line.data.datasets.splice(3, 0, {
                label: "Bueno",
                data: [0],
                backgroundColor: ["rgba(0, 208, 132, 0.5)"],
                borderWidth: 1,
                borderColor: ["rgba(85, 139, 47, 0.6)"],
            });

            data.polar.data.labels.splice(1, 0, "Muy Malo");

            data.polar.data.labels.splice(3, 0, "Bueno");

            data.polar.data.datasets[0].backgroundColor.splice(1, 0, "rgba(255, 0, 0, 0.5)");

            data.polar.data.datasets[0].backgroundColor.splice(3, 0, "rgba(85, 139, 47, 0.6)");

            data.polar.data.datasets[0].data = [0, 0, 0, 0, 0];
        }

        if (data.tipo == 1) {
            
            data.checks.forEach((check) => {
                let rgba = `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}`;
                data.line.data.datasets.push({
                    label: check,
                    data: [0],
                    backgroundColor: [`${rgba}, 0.5)`],
                    borderWidth: 1,
                    borderColor: [`${rgba}, 0.6)`],
                });
                
                data.polar.data.labels.push(check);
                data.polar.data.datasets[0].data.push(0);
                data.polar.data.datasets[0].backgroundColor.push(`${rgba}`);

            });
 
                
        }

        return data;
    }
    

    conteotranscurrido(data, list) {

        if (typeof data.respuesta === 'number' && !isNaN(data.respuesta)) {
            list.line.data.datasets[data.respuesta].data[0]++;
            list.polar.data.datasets[0].data[data.respuesta]++;
        }
        
        if (Array.isArray(data.respuesta)) {
            data.respuesta.forEach(check => {
                
               
                list.line.data.datasets[check].data[0]++;
                list.polar.data.datasets[0].data[check]++;;
            });
        }

        return list;
    }

    tiempoTranscurrido(t1, t2) {
    const ms1 = t1.seconds * 1000 + t1.nanoseconds / 1_000_000;
    const ms2 = t2.seconds * 1000 + t2.nanoseconds / 1_000_000;

    const diferenciaMs = Math.abs(ms2 - ms1);

    const totalSegundos = Math.round(diferenciaMs / 1000);
      
    return `${Math.floor(totalSegundos / 60)}.${totalSegundos % 60}`;
}

    calcularTiempoTranscurrido(t1, t2) {
        
        return Math.floor((t2.seconds + t2.nanoseconds / 1e9) - (t1.seconds + t1.nanoseconds / 1e9));
    }

    gettime(t1, t2) {
    // Calcular tiempo total en segundos con nanosegundos
    const tiempo1 = t1.seconds + t1.nanoseconds / 1e9;
    const tiempo2 = t2.seconds + t2.nanoseconds / 1e9;
    
    let diferenciaSegundos = tiempo2 - tiempo1;
    
    // Limitar a 60 minutos máximo (3600 segundos)
    if (diferenciaSegundos > 3600) {
        diferenciaSegundos = 3600;
    }
    
    // Calcular minutos y segundos
    const minutos = Math.floor(diferenciaSegundos / 60);
    const segundos = diferenciaSegundos % 60;
    
    // Formatear como "minutos.segundos" con dos dígitos en segundos
    const segundosFormateados = segundos.toFixed(2).padStart(5, '0');
    
    return `${minutos}.${segundosFormateados.split('.')[1]}`;
    }

    formatearTiempo = (segundos) => {
        /* console.log(segundos); */

        if (segundos < 0) return '00';

        const horas = Math.floor(segundos / 3600);
        const minutos = Math.floor((segundos % 3600) / 60);
        const segs = segundos % 60;

        return [
            horas.toString().padStart(2, '0'),
            minutos.toString().padStart(2, '0'),
            segs.toString().padStart(2, '0')
        ].join(':');
    };



   getSC(min) {
    if (min < 15) return "Bueno";
  if (min <= 30) return "Regular";
  if (min <= 40) return "Malo";
  return "Muy Malo";
  }



}